import { render, staticRenderFns } from "./DialogRssSettings.vue?vue&type=template&id=6aa130d0"
import script from "./DialogRssSettings.vue?vue&type=script&lang=js"
export * from "./DialogRssSettings.vue?vue&type=script&lang=js"
import style0 from "./DialogRssSettings.vue?vue&type=style&index=0&id=6aa130d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports